import React from 'react'
import PropTypes from 'prop-types'
import { getWarrantyName } from '../helpers'

const Warranty = ({ warrantyName, warrantyValue }) =>
  <div><b>{ getWarrantyName(warrantyName) }</b>: { warrantyValue }</div>

Warranty.propTypes = {
  warrantyName: PropTypes.string,
  warrantyValue: PropTypes.string
}

export default Warranty
